import typeToReducer from 'type-to-reducer'


const initialState = {
    chatUsers: null,
    conversation: null,
    newMessage: null
};

const reducer = typeToReducer({
    ['GET_CHAT_USERS']: (state, action) => ({
        ...state,
        chatUsers: action.payload
    }),
    ['GET_CONVERSATION']: (state, action) => ({
        ...state,
        conversation: action.payload
    }),
    ['NEW_MESSAGE']: (state, action) => ({
        ...state,
        newMessage: action.payload
    }),
    ['SEEN_NEW_MESSAGE']: (state, action) => ({
        ...state,
        newMessage: null
    })
}, initialState);


export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/livechat.js